import React, { useState } from 'react';
import Navbar from './components/Navbar';
import './styles.css';
import Modal from './components/Modal';

// ПРАВИЛЬНО: Компоненты объявлены снаружи, на верхнем уровне модуля.
const StarIcon = ({ className }) => (
  <svg
    className={className}
    width="47"
    height="47"
    viewBox="0 0 47 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.92337 22.3065L17.0646 17.159L22.2088 3.02107C22.3267 2.6972 22.5414 2.41745 22.8238 2.21977C23.1061 2.02209 23.4425 1.91606 23.7871 1.91606C24.1318 1.91606 24.4682 2.02209 24.7505 2.21977C25.0329 2.41745 25.2476 2.6972 25.3655 3.02107L30.513 17.1623L44.6543 22.3065C44.9782 22.4244 45.2579 22.6391 45.4556 22.9215C45.6533 23.2038 45.7593 23.5402 45.7593 23.8848C45.7593 24.2295 45.6533 24.5659 45.4556 24.8482C45.2579 25.1306 44.9782 25.3453 44.6543 25.4632L30.5097 30.6107L25.3655 44.752C25.2476 45.0759 25.0329 45.3556 24.7505 45.5533C24.4682 45.751 24.1318 45.857 23.7871 45.857C23.4425 45.857 23.1061 45.751 22.8238 45.5533C22.5414 45.3556 22.3267 45.0759 22.2088 44.752L17.0613 30.6074L2.92337 25.4632C2.5995 25.3453 2.31974 25.1306 2.12207 24.8482C1.92439 24.5659 1.81836 24.2295 1.81836 23.8848C1.81836 23.5402 1.92439 23.2038 2.12207 22.9215C2.31974 22.6391 2.5995 22.4244 2.92337 22.3065Z"
      stroke="white"
      strokeOpacity="0.21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ShiningStarIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_shining_star)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8072 1.30999C16.1712 -0.436012 13.7032 -0.436012 13.0672 1.30999L10.1812 9.24399L2.24724 12.13C0.501244 12.766 0.501244 15.234 2.24724 15.87L10.1812 18.756L13.0672 26.69C13.7032 28.436 16.1712 28.436 16.8072 26.69L19.6932 18.756L27.6272 15.87C29.3732 15.234 29.3732 12.766 27.6272 12.13L19.6932 9.24399L16.8072 1.30999Z"
        fill="#CCCCCC"
      />
    </g>
    <defs>
      <clipPath id="clip0_shining_star">
        <rect width="28" height="28" fill="white" transform="translate(0.9375)" />
      </clipPath>
    </defs>
  </svg>
);

// Главный компонент приложения
function App() {
  // ПРАВИЛЬНО: Хуки вызываются на верхнем уровне ВНУТРИ тела компонента App.
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // ПРАВИЛЬНО: JSX возвращается после всей логики.
  return (
    <div className="app-container">
      {/* --- Секция 1 --- */}
      <section id="section1" className="section">
        <div className="stars-background-section1">
          <ShiningStarIcon className="s1-star s1-star-1" />
          <ShiningStarIcon className="s1-star s1-star-2" />
          <ShiningStarIcon className="s1-star s1-star-3" />
          <ShiningStarIcon className="s1-star s1-star-4" />
          <ShiningStarIcon className="s1-star s1-star-5" />
          <ShiningStarIcon className="s1-star s1-star-6" />
          <ShiningStarIcon className="s1-star s1-star-7" />
          <ShiningStarIcon className="s1-star s1-star-8" />
          <ShiningStarIcon className="s1-star s1-star-9" />
        </div>
        <Navbar />
        <div className="content">
          {/* <h4>KikoAI</h4> удалено, т.к. KikoAi уже есть в навбаре */}
          {/* Главный заголовок */}
          <h1 className="main-headline">
            More Laughter. <br />
            Deeper Bonds. <br />
            Your Home, Alive with <br />
            Connection
          </h1>

          {/* Подзаголовок/описание */}
          <p className="sub-paragraph">
            We're reimagining how families interact with technology. KikoAI is
            creating shared adventures and joyful rituals, turning everyday
            spaces into worlds of wonder, right where you live.
          </p>

          {/* Кнопка */}
          <button className="cta-button" onClick={handleOpenModal}>
            <span>Sign up</span>
            {/* Иконка волшебной палочки (SVG) */}
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.25 21.75C11.25 21.75 12.75 18.75 15 18.75C17.25 18.75 18.75 21.75 18.75 21.75M12.75 3.75L13.0645 5.56452C13.2036 6.35339 13.8466 6.99645 14.6355 7.13553L16.45 7.45M3.75 15.75L5.56452 15.4355C6.35339 15.2964 6.99645 14.6534 7.13553 13.8645L7.45 12.05M9.75 9.75L11.25 2.25L14.25 9.75L21.75 11.25L14.25 12.75L11.25 20.25L9.75 12.75L2.25 11.25L9.75 9.75Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        {/* Этот div отвечает за эффект свечения */}
        <div className="glow-effect"></div>
      </section>

      {/* --- Секция 2 --- */}
      <section id="section2" className="section">
        <div className="section2-content-wrapper">
          <div className="text-block">
            <h2 className="section2-headline">
              The Invisible Walls in Our Homes
            </h2>
            <p className="section2-paragraph">
              Even when close, screens can divide. Precious moments slip by, lost
              to individual digital worlds. KikoAI is dedicated to dissolving these
              barriers, using technology to draw your family closer, not further
              apart.
            </p>
          </div>

          <div className="image-placeholder">
            <img
              src="aa.jpg"
              alt="Family interacting with KikoAI"
              className="section2-image"
            />
          </div>
        </div>
      </section>

      {/* --- Секция 3 --- */}
      <section id="section3" className="section">
        <div className="section3-layout">
          <div className="text-content-left">
            <h2 className="section3-headline">
              Our Vision: Beyond<br />
              Screens, A Living<br />
              Canvas for Your Family
            </h2>
            <p className="section3-paragraph">
              At KikoAI, we see a future where your home actively nurtures
              family ties. We're building intuitive, AI-driven experiences that
              seamlessly weave into the fabric of your life, making genuine
              shared moments easy and delightful.
            </p>
          </div>
          <div className="image-placeholder-right">
            <img src='bb.png' alt="KikoAI vision" className="section3-image" />
          </div>
        </div>
      </section>

      {/* --- Секция 4 --- */}
      <section id="section4" className="section">
        <div className="section4-wrapper">
          <h2 className="section4-main-headline">
            One Device. Endless Possibilities.
          </h2>
          <div className="feature-card">
            <div className="card-text-content">
              <h3 className="card-headline">
                The Future of Interaction: Intelligent Projection & Embodied AI.
              </h3>
              <p className="card-paragraph">
                At the core of KikoAI is a fusion of cutting-edge technologies
                designed to create truly intuitive and engaging family
                experiences. We're not just building a device; we're
                architecting a new kind of interactive environment.
              </p>
              <div className="tags-container">
                {[
                  'Deep Learning AI',
                  'Spatial Computing',
                  'Generative Content Models',
                  'Scene Understanding',
                  'Embodied Intelligence',
                  'Edge AI Integration',
                ].map((tag, index) => (
                  <button key={index} className="feature-tag">
                    {tag}
                  </button>
                ))}
              </div>
            </div>
            <div className="card-image-placeholder">
              <img src='cc.png' alt="KikoAI device technology" className="card-image" />
            </div>
          </div>
        </div>
      </section>

      {/* --- Секция 5 --- */}
      <section id="section5" className="section">
        <div className="newsletter-card">
          <div className="stars-background">
            <StarIcon className="star-1" />
            <StarIcon className="star-2" />
            <StarIcon className="star-3" />
            <StarIcon className="star-4" />
          </div>
          <div className="newsletter-content">
            <h2 className="newsletter-headline">
              Gather 'Round for KikoAI News.
              <br />
              First look at how our AI Campfire sparks joy
            </h2>
            <div className="email-form-container" onClick={handleOpenModal}>
              <span className="email-input-placeholder">Enter your email</span>
              <button className="subscribe-button">Subscribe</button>
            </div>
          </div>
        </div>
        <div className='last-info'>
          <span>© 2025— KikoAI</span>
        </div>
      </section>
      
      {/* Модальное окно рендерится здесь */}
      <Modal show={showModal} onClose={handleCloseModal} />
    </div>
  );
}

export default App;
